// Handles a single block's font resizing behavior
class FontResizerItem {
  constructor({ element, widthAttribute }) {
    this.element = element;

    // Read base width from attribute or fallback to current width
    const widthAttr = this.element.getAttribute(widthAttribute);
    this.standardWidth = parseInt(widthAttr, 10) || this.element.offsetWidth;

    // Observe size changes and adjust font size
    this.resizeObserver = new ResizeObserver(() => this.adjustFontSize());
    this.resizeObserver.observe(this.element);
  }

  // Updates CSS variable --fz based on element's current width
  adjustFontSize() {
    const currentWidth = this.element.offsetWidth;
    let fontSizeRatio = currentWidth / this.standardWidth;
    fontSizeRatio = Number(fontSizeRatio.toFixed(3));

    this.element.style.setProperty('--fz', `${fontSizeRatio}em`);
  }
}

// Manages all font resizable blocks
class FontResizerController {
  constructor(settings) {
    this.settings = settings;
    this.blocks = [];
  }

  // Initializes all matching blocks on first run
  init() {
    const blocks = document.querySelectorAll(this.settings.selectors.block);
    blocks.forEach(block => this.applyTo(block));
  }

  // Initializes only unprocessed blocks
  bindNew() {
    this.getUnboundBlocks().forEach(block => this.applyTo(block));
  }

  // Returns elements not yet initialized
  getUnboundBlocks() {
    const all = document.querySelectorAll(this.settings.selectors.block);
    const initialized = this.blocks.map(b => b.element);
    return Array.from(all).filter(el => !initialized.includes(el));
  }

  // Applies resizing logic to a single element
  applyTo(element) {
    const instance = new FontResizerItem({
      element,
      widthAttribute: this.settings.widthAttribute
    });
    this.blocks.push(instance);
  }
}

export default FontResizerController;
